export * from "./ConsumablesQuantityItemText";
